import React from "react";
import SvgDisableWarning from "./helpers/SvgDisableWarning";

interface props {
  message: string;
}
const DisabledMethodMSg: React.FC<props> = ({ message }) => {
  return (
    <div className="disabed-method">
      <SvgDisableWarning />
      <p>{message}</p>
    </div>
  );
};

export default DisabledMethodMSg;
